import { ApiError, getReport } from '@schooly/api';
import { buildFiltersSearchParams } from '@schooly/components/filters';
import { useNotifications } from '@schooly/components/notifications';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { reportToMarkbookFilters } from './reportToMarkbookFilters';

export const useOpenMarkbookFromReport = (fallbackDate: [string, string]) => {
  const navigate = useNavigate();
  const { showError } = useNotifications();
  const [isMarkbookOpening, setIsMarkbookOpening] = useState(false);

  const openMarkbook = useCallback(
    async (reportId: string) => {
      if (isMarkbookOpening) return;
      try {
        setIsMarkbookOpening(true);
        const detail = await getReport(reportId);
        if (!detail) return;
        const search = buildFiltersSearchParams(reportToMarkbookFilters(detail, fallbackDate));
        navigate(`/markbook/filters/preview${search ? `?${search}` : ''}`);
      } catch (error) {
        showError(error as ApiError);
      } finally {
        setIsMarkbookOpening(false);
      }
    },
    [fallbackDate, isMarkbookOpening, navigate, showError],
  );

  return { openMarkbook, isMarkbookOpening };
};
